import { CheckIcon, RobotIcon, Tag, TagVariants } from '../../../components';
import { useTask } from '../utils/hooks';
import { TaskStatus, TaskType } from '../utils/types';

export const TaskHeader = () => {
  const {
    title,
    status,
    source: { type },
  } = useTask();

  const isTodo = status === TaskStatus.Todo;
  const isDone = status === TaskStatus.Done;

  return (
    <header className="flex flex-col gap-y-4">
      {type === TaskType.Requirement && !isTodo && (
        <div className="w-fit">
          <Tag
            variant={isDone ? TagVariants.Lime : TagVariants.Violet}
            text={isDone ? 'Complete' : 'Automated'}
            icon={isDone ? CheckIcon : RobotIcon}
          />
        </div>
      )}

      <h1 className="grow text-4xl font-black">{title}</h1>
    </header>
  );
};
